// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-searchbar {
  position: relative;
  transition: none;
  width: 100%;
  height: 100%;
}
@media (max-width: 768px) {
  .header-searchbar {
    display: none;
  }
}
.header-searchbar-notfound {
  width: 100%;
  padding: 2rem;
  align-items: center;
  display: flex;
  flex-direction: column;
}
.header-searchbar-notfound-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  background: var(--purple0);
  width: 3rem;
  height: 3rem;
  margin-bottom: 1.5rem;
}
.header-searchbar-notfound-title {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: var(--black9);
  margin-bottom: 0.5rem;
}
.header-searchbar-notfound-description {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--black5);
}
.header-searchbar-container {
  position: relative;
  background: var(--white);
  box-shadow: 0 2px 4px -1px rgba(7, 14, 35, 0.08), 0px 2px 24px -2px rgba(7, 14, 35, 0.12);
  width: 100%;
  border-radius: 0.5rem;
  bottom: 0;
  left: -0.5rem;
  opacity: 1;
  visibility: visible;
  z-index: 999;
}
.header-searchbar-container.hide {
  opacity: 0;
  visibility: hidden;
  z-index: -1;
}
.header-searchbar-container .search-item {
  padding: 0.5rem;
  cursor: pointer;
  display: flex;
}
.header-searchbar-container .search-item:hover {
  background: var(--black0);
  border-radius: 0.5rem;
}
.header-searchbar-container .search-item-icon {
  width: 32px;
  height: 32px;
  border: 1px solid var(--black2);
  background: var(--white);
  box-shadow: 0px 1px 2px rgba(18, 20, 23, 0.06);
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.75rem;
}
.header-searchbar-container .search-item-icon img {
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 0.5rem;
}
.header-searchbar-container .search-item-icon svg * {
  stroke: var(--black3);
}
.header-searchbar-container .search-item-icon + div {
  color: var(--black9);
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
}
.header-searchbar-container .search-item-icon + div > span:last-child {
  color: var(--black4);
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  display: flex;
}
.header-searchbar-container .search-categories {
  display: flex;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  color: var(--black4);
}
.header-searchbar-container .search-categories > div {
  position: relative;
  text-transform: capitalize;
  cursor: pointer;
  padding: 1rem 0;
  margin-right: 1rem;
}
.header-searchbar-container .search-categories > div.active {
  color: var(--black9);
}
.header-searchbar-container .search-categories > div.active:after {
  content: "";
  width: 100%;
  height: 2px;
  background: var(--purple6);
  display: flex;
  position: absolute;
  top: calc(100% - 1px);
  border-radius: 2px;
}
.header-searchbar-container .search-body {
  padding: 0.5rem;
  max-height: 200px;
  overflow: auto;
}
.header-searchbar-container .search-header {
  padding: 0 1rem 0 1rem;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  color: var(--black4);
  border-bottom: 1px solid var(--black1);
}
.header-searchbar-input {
  padding-bottom: 0.5rem;
}
.header-searchbar-input > svg {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0.25rem;
  color: var(--black3);
}
.header-searchbar-input > input {
  background-color: var(--white);
  height: 100%;
  border: none !important;
  padding-left: 2rem;
  transition: none;
  width: 100%;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: var(--black9);
  font-weight: 600;
}
.header-searchbar-input > input::placeholder {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: var(--black3);
}
.header-searchbar-input > input:focus {
  outline: none;
}
.header-searchbar-input > input:focus + svg {
  color: var(--black9);
}`, "",{"version":3,"sources":["webpack://./client/components/header/components/searchbar.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AACF;AACE;EANF;IAOI,aAAA;EAEF;AACF;AAAE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;AAEJ;AAAI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;AAEN;AACI;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,qBAAA;AACN;AACI;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AACN;AAGE;EACE,kBAAA;EACA,wBAAA;EACA,yFAAA;EACA,WAAA;EACA,qBAAA;EACA,SAAA;EACA,aAAA;EACA,UAAA;EACA,mBAAA;EACA,YAAA;AADJ;AAGI;EACE,UAAA;EACA,kBAAA;EACA,WAAA;AADN;AAII;EACE,eAAA;EACA,eAAA;EACA,aAAA;AAFN;AAIM;EACE,yBAAA;EACA,qBAAA;AAFR;AAKM;EACE,WAAA;EACA,YAAA;EACA,+BAAA;EACA,wBAAA;EACA,8CAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;AAHR;AAKQ;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;AAHV;AAMQ;EACE,qBAAA;AAJV;AAOQ;EACE,oBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AALV;AAQY;EACE,oBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;AANd;AAgBM;EACE,aAAA;EAEA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AAfR;AAiBQ;EACE,kBAAA;EACA,0BAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AAfV;AAiBU;EACE,oBAAA;AAfZ;AAiBY;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,0BAAA;EACA,aAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;AAfd;AAqBM;EACE,eAAA;EACA,iBAAA;EACA,cAAA;AAnBR;AAsBM;EACE,sBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,sCAAA;AApBR;AAyBE;EACE,sBAAA;AAvBJ;AAyBI;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,aAAA;EACA,oBAAA;AAvBN;AA0BI;EACE,8BAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EAEA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;AAzBN;AA4BM;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AA1BR;AA6BM;EACE,aAAA;AA3BR;AA4BQ;EACE,oBAAA;AA1BV","sourcesContent":[".header-searchbar {\n  position: relative;\n  transition: none;\n  width: 100%;\n  height: 100%;\n\n  @media (max-width: 768px) {\n    display: none;\n  }\n\n  &-notfound {\n    width: 100%;\n    padding: 2rem;\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n\n    &-icon {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 100%;\n      background: var(--purple0);\n      width: 3rem;\n      height: 3rem;\n      margin-bottom: 1.5rem;\n    }\n\n    &-title {\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 600;\n      font-size: 16px;\n      line-height: 19px;\n      text-align: center;\n      color: var(--black9);\n      margin-bottom: .5rem;\n    }\n    &-description {\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 400;\n      font-size: 14px;\n      line-height: 20px;\n      color: var(--black5);\n    }\n  }\n\n  &-container {\n    position: relative;\n    background: var(--white);\n    box-shadow: 0 2px 4px -1px rgba(7, 14, 35, 0.08), 0px 2px 24px -2px rgba(7, 14, 35, 0.12);\n    width: 100%;\n    border-radius: .5rem;\n    bottom: 0;\n    left: -.5rem;\n    opacity: 1;\n    visibility: visible;\n    z-index: 999;\n\n    &.hide {\n      opacity: 0;\n      visibility: hidden;\n      z-index: -1;\n    }\n\n    .search-item {\n      padding: .5rem;\n      cursor: pointer;\n      display: flex;\n\n      &:hover {\n        background: var(--black0);\n        border-radius: .5rem;\n      }\n\n      &-icon {\n        width: 32px;\n        height: 32px;\n        border: 1px solid var(--black2);\n        background: var(--white);\n        box-shadow: 0px 1px 2px rgba(18, 20, 23, 0.06);\n        border-radius: .5rem;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        margin-right: .75rem;\n\n        img {\n          width: 100%;\n          height: 100%;\n          overflow: hidden;\n          border-radius: .5rem;\n        }\n\n        svg * {\n          stroke: var(--black3);\n        }\n\n        & + div {\n          color: var(--black9);\n          font-family: 'Inter';\n          font-style: normal;\n          font-weight: 500;\n          font-size: 14px;\n          line-height: 17px;\n\n          & > span {\n            &:last-child {\n              color: var(--black4);\n              font-family: 'Inter';\n              font-style: normal;\n              font-weight: 400;\n              font-size: 12px;\n              line-height: 15px;\n              display: flex;\n              //margin-top: 4px;\n            }\n          }\n        }\n      }\n    }\n\n    .search {\n\n      &-categories {\n        display: flex;\n\n        font-family: 'Inter';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 13px;\n        line-height: 16px;\n        color: var(--black4);\n\n        & > div {\n          position: relative;\n          text-transform: capitalize;\n          cursor: pointer;\n          padding: 1rem 0;\n          margin-right: 1rem;\n\n          &.active {\n            color: var(--black9);\n\n            &:after {\n              content: \"\";\n              width: 100%;\n              height: 2px;\n              background: var(--purple6);\n              display: flex;\n              position: absolute;\n              top: calc(100% - 1px);\n              border-radius: 2px;\n            }\n          }\n        }\n      }\n\n      &-body {\n        padding: .5rem;\n        max-height: 200px;\n        overflow: auto;\n      }\n\n      &-header {\n        padding: 0 1rem 0 1rem;\n        font-family: 'Inter';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 13px;\n        line-height: 16px;\n        color: var(--black4);\n        border-bottom: 1px solid var(--black1);\n      }\n    }\n  }\n\n  &-input {\n    padding-bottom: .5rem;\n\n    & > svg {\n      position: absolute;\n      top: 50%;\n      transform: translateY(-50%);\n      left: .25rem;\n      color: var(--black3);\n    }\n\n    & > input {\n      background-color: var(--white);\n      height: 100%;\n      border: none !important;\n      padding-left: 2rem;\n      transition: none;\n      width: 100%;\n\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 400;\n      font-size: 14px;\n      line-height: 17px;\n      color: var(--black9);\n      font-weight: 600;\n\n\n      &::placeholder {\n        font-family: 'Inter';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 17px;\n        color: var(--black3);\n      }\n\n      &:focus {\n        outline: none;\n        + svg {\n          color: var(--black9);\n        }\n      }\n\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
